import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,
} from "../Services/Urls";

import { callApi, makeApiRequest } from "../Services/ApiService";
import { decryptOtp } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { getRecords, PostRecords } from "../Services/ApiCall";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import Footer from "../Common/Footer";
import Header from "../Common/Header";

import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";

import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";

import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import { getUserLocation } from "../Services/Helper";

function SidebarProjects({ filters, tabID, onChange }) {
  const { logindata, setlogindata, userData, setuserData, coordinates } =
    useContext(ApiContext);

  const [PropertyTypeData, setPropertyTypeData] = useState([]);
  const [Selected_PropertyType, setSelectedPropertyType] = useState([]);
  const [AmenitiesData, setAmenitiesData] = useState([]);
  const [Selected_AmenitiesData, setSelectedAmenitiesData] = useState([]);

  const [CityData, setCityData] = useState([]);
  const [Selected_CityData, setSelectedCityData] = useState([]);

  const [developerData, setDeveloperData] = useState([]);
  const [Selected_developerData, setSelectedDeveloperData] = useState([]);
  const [ProjectStatusData, setProjectStatusData] = useState([]);
  const [Selected_ProjectStatusData, setSelectedProjectStatusData] = useState(
    [],
  );

  const [MinBudget, setMinBudget] = useState("");
  const [MaxBudget, setMaxBudget] = useState("");

  const [MinCarpetArea, setMinCarpetArea] = useState("");
  const [MaxCarpetArea, setMaxCarpetArea] = useState("");

  useEffect(() => {
    getPropertyType();
    // getDeveloper();
    getProjectStatus();
    getCitys();
    getpropertyAmenities();
  }, []);

  const getPropertyType = () => {
    getRecords(391, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyTypeData(data?.response?.records || []);

          // if (tabID != null) {
          //   const records = data?.response?.records || [];
          //   const selected =
          //     tabID == 384 || tabID == 385 || tabID == 386
          //       ? records.find((x) => x.PropertyTypeID === 1)
          //       : records.find((x) => x.PropertyTypeID === 2);

          //   setSelectedProperType(selected || null);
          // }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getDeveloper = () => {
    getRecords(417, 150, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setDeveloperData(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getProjectStatus = () => {
    getRecords(406, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setProjectStatusData(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getCitys = () => {
    let query =
      coordinates != null
        ? `{'Coordinates': {'\$nearSphere': {'\$geometry': {'type':'Point','coordinates':[${coordinates?.longitude}, ${coordinates?.latitude}]}, '\$maxDistance': 30000000}}}`
        : `{}`;
    getRecords(260, 100, query, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setCityData(data?.response?.records || []);
          if (filters?.cityIds != null && filters?.cityIds.length > 0) {
            const selected = data?.response?.records.filter((item) =>
              filters?.cityIds.includes(item.CityID),
            );
            setSelectedCityData(selected || []);
          }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getpropertyAmenities = () => {
    getRecords(396, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setAmenitiesData(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const [showAllCities, setShowAllCities] = useState(false);

  const VISIBLE_COUNT = 5;
  const visibleCities = showAllCities
    ? CityData
    : CityData?.slice(0, VISIBLE_COUNT);

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-widget style4">
          <div className="d-flexx">
            <h6 className="d-desk">Filters</h6>
            <a
              onClick={() => {
                setSelectedAmenitiesData([]);
                Selected_CityData([]);
                Selected_ProjectStatusData([]);
                setMinBudget("");
                setMaxBudget("");
                setMinCarpetArea("");
                setMaxCarpetArea("");

                onChange(() => ({
                  status: 2,
                }));
              }}
            >
              Clear All
            </a>
          </div>

          {/* <div className="fblock">
            <strong>Property Type</strong>
            {PropertyTypeData?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.PropertyTypeID}
                  checked={Selected_PropertyType.some(
                    (v) => v.PropertyTypeID === type.PropertyTypeID,
                  )}
                  onChange={() => {
                    setSelectedPropertyType((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.PropertyTypeID === type.PropertyTypeID,
                      )
                        ? prev.filter(
                            (v) => v.PropertyTypeID !== type.PropertyTypeID,
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        propertyTypeIds: nextSelected.map(
                          (item) => item.PropertyTypeID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.PropertyType}>{type?.PropertyType}</label>
              </div>
            ))}
          </div> */}

          <div className="fblock">
            <strong>Project Status</strong>
            {ProjectStatusData?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.ConstructionStatusID}
                  checked={Selected_ProjectStatusData.some(
                    (v) => v.ConstructionStatusID === type.ConstructionStatusID,
                  )}
                  onChange={() => {
                    setSelectedProjectStatusData((prev) => {
                      const nextSelected = prev.some(
                        (v) =>
                          v.ConstructionStatusID === type.ConstructionStatusID,
                      )
                        ? prev.filter(
                            (v) =>
                              v.ConstructionStatusID !==
                              type.ConstructionStatusID,
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        projectStatusIds: nextSelected.map(
                          (item) => item.ConstructionStatusID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.ConstructionStatusID}>
                  {type?.ConstructionStatus}
                </label>
              </div>
            ))}
            {/* <a href="#">View More</a> */}
          </div>

          <div className="fblock">
            <strong>Society Amenities</strong>
            {AmenitiesData?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.PropertyAmenitiesID}
                  checked={Selected_AmenitiesData.some(
                    (v) => v.PropertyAmenitiesID === type.PropertyAmenitiesID,
                  )}
                  onChange={() => {
                    setSelectedAmenitiesData((prev) => {
                      const nextSelected = prev.some(
                        (v) =>
                          v.PropertyAmenitiesID === type.PropertyAmenitiesID,
                      )
                        ? prev.filter(
                            (v) =>
                              v.PropertyAmenitiesID !==
                              type.PropertyAmenitiesID,
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        societyAmenities: nextSelected.map(
                          (item) => item.PropertyAmenitiesID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor="Lift">{type?.PropertyAmenities}</label>
              </div>
            ))}
            {/* <a href="#">View More</a> */}
          </div>

          <div className="fblock">
            <strong>Budget</strong>
            <div style={{ marginTop: 4 }} className="d-block">
              <div className="form-group">
                <input
                  value={MinBudget}
                  onChange={(e) => {
                    setMinBudget(e.target.value);
                  }}
                  type="text"
                  placeholder="Min"
                />
              </div>
            </div>
            <div className="d-block">
              <div className="form-group">
                <input
                  value={MaxBudget}
                  onChange={(e) => {
                    setMaxBudget(e.target.value);
                  }}
                  type="text"
                  placeholder="Max"
                />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <button
                disabled={!MinBudget && !MaxBudget}
                style={{
                  width: "85%",
                  backgroundColor:
                    !MinBudget && !MaxBudget ? "#9ca3af" : "#16a34a", // disabled / active color
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  padding: "5px 5px",
                  cursor: !MinBudget && !MaxBudget ? "not-allowed" : "pointer",
                  fontWeight: "400",
                  marginTop: "3px",
                  transition: "0.2s ease",
                  opacity: !MinBudget && !MaxBudget ? 0.7 : 1,
                }}
                onMouseOver={(e) => {
                  if (MinBudget && MaxBudget) {
                    e.target.style.backgroundColor = "#15803d";
                  }
                }}
                onMouseOut={(e) => {
                  if (MinBudget && MaxBudget) {
                    e.target.style.backgroundColor = "#16a34a";
                  }
                }}
                onClick={() => {
                  //  console.log("Min:", MinBudget, "Max:", MaxBudget);
                  onChange((filtersPrev) => ({
                    ...filtersPrev,
                    budgetFrom: MinBudget,
                    budgetTo: MaxBudget,
                  }));
                }}
              >
                Apply
              </button>
            </div>
          </div>

          <div className="fblock">
            <strong>Carpet Area</strong>
            <div style={{ marginTop: 4 }} className="d-block">
              <div className="form-group">
                <input
                  value={MinCarpetArea}
                  onChange={(e) => {
                    setMinCarpetArea(e.target.value);
                  }}
                  type="text"
                  placeholder="Min"
                />
              </div>
            </div>
            <div className="d-block">
              <div className="form-group">
                <input
                  value={MaxCarpetArea}
                  onChange={(e) => {
                    setMaxCarpetArea(e.target.value);
                  }}
                  type="text"
                  placeholder="Max"
                />
              </div>
            </div>

            <div style={{ width: "100%" }}>
              <button
                disabled={!MinCarpetArea && !MaxCarpetArea}
                style={{
                  width: "85%",
                  backgroundColor:
                    !MinCarpetArea && !MaxCarpetArea ? "#9ca3af" : "#16a34a", // disabled / active color
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  padding: "5px 5px",
                  cursor:
                    !MinCarpetArea && !MaxCarpetArea
                      ? "not-allowed"
                      : "pointer",
                  fontWeight: "400",
                  marginTop: "3px",
                  transition: "0.2s ease",
                  opacity: !MinCarpetArea && !MaxCarpetArea ? 0.7 : 1,
                }}
                onMouseOver={(e) => {
                  if (MinCarpetArea && MaxCarpetArea) {
                    e.target.style.backgroundColor = "#15803d";
                  }
                }}
                onMouseOut={(e) => {
                  if (MinCarpetArea && MaxCarpetArea) {
                    e.target.style.backgroundColor = "#16a34a";
                  }
                }}
                onClick={() => {
                  onChange((filtersPrev) => ({
                    ...filtersPrev,
                    CarpetAreaFrom: MinCarpetArea,
                    CarpetAreaTo: MaxCarpetArea,
                  }));
                }}
              >
                Apply
              </button>
            </div>
          </div>

          {/* <div className="fblock">
            <strong>Developers</strong>
            {developerData?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.DeveloperID}
                  checked={Selected_developerData.some(
                    (v) => v.DeveloperID === type.DeveloperID,
                  )}
                  onChange={() => {
                    setSelectedDeveloperData((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.DeveloperID === type.DeveloperID,
                      )
                        ? prev.filter((v) => v.DeveloperID !== type.DeveloperID) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        developers: nextSelected.map(
                          (item) => item.DeveloperID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor="Lift">{type?.DeveloperName}</label>
              </div>
            ))}
          </div> */}
          <div className="fblock">
            <strong>Cities</strong>

            {visibleCities?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.CityID}
                  checked={Selected_CityData.some(
                    (v) => v.CityID === type.CityID,
                  )}
                  onChange={() => {
                    setSelectedCityData((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.CityID === type.CityID,
                      )
                        ? prev.filter((v) => v.CityID !== type.CityID)
                        : [...prev, type];

                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        cityIds: nextSelected.map((item) => item.CityID),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type.CityID}>{type.City}</label>
              </div>
            ))}

            {CityData?.length > VISIBLE_COUNT && (
              <a
                style={{ cursor: "pointer", color: "#1e88e5" }}
                onClick={() => setShowAllCities((prev) => !prev)}
              >
                {showAllCities ? "View Less" : "View More"}
              </a>
            )}
          </div>
          <div className="bottombtn d-mobile">
            <a className="btn style1">Apply Filter</a>
          </div>
        </div>
      </div>
    </>
  );
}

export default SidebarProjects;
